import { FC, useEffect } from 'react';
import { Box } from '@mui/material';
import { QuestSchema } from 'src/types/quests';
import useAppDispatch from 'src/hooks/useAppDispatch';
import { fetchPlanningSession } from 'src/redux/planning/service';
import { resetPlanning } from 'src/redux/planning/slice';
import { RootState } from 'src/redux/store';
import { useSelector } from 'react-redux';
import ExpandablePlan from 'src/shared/ExpandablePlan';

interface Props {
    quest: QuestSchema;
}

const PlanningSection: FC<Props> = ({ quest }) => {
    const dispatch = useAppDispatch();
    const plan = useSelector((s: RootState) => s.planning?.plan);

    useEffect(() => {
        dispatch(resetPlanning());
        if (quest.planningSessionId) {
            dispatch(fetchPlanningSession(String(quest.planningSessionId)));
        }
    }, [quest.planningSessionId, dispatch]);

    if (!quest.planningSessionId || !plan) return null;

    return (
        <Box mt={4}>
            <ExpandablePlan plan={plan} title="Implementation Plan" />
        </Box>
    );
};

export default PlanningSection;
